var __TEMP__ = require('./_createBaseFor.js');var createBaseFor = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseForRight;
